import { connect } from "react-redux";
import ChildLinksComponent from "./component";
import { getCategoryChildLinks } from "../../state/modules/category";

const mapStateToProps = state => ({
  pills: getCategoryChildLinks(state)
});

export default connect(mapStateToProps)(ChildLinksComponent);
